<script>
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/vue";
import { getCurrentInstance, onMounted} from "vue";

export default {
  name: "TilesetServices",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
  },
  setup(props) {

    const instance = getCurrentInstance();

    const instanceId = instance ? instance.uid : null;
    const modules = [Navigation];

    onMounted(() => {
      console.log(instanceId);
    })
    return {
      modules: modules,
      instanceId
    };
  },
};
</script>

<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import tileset-services
    @import tile-service
</style>
